import { render, staticRenderFns } from "./DetailsNew.vue?vue&type=template&id=7c7e7079&scoped=true"
import script from "./DetailsNew.vue?vue&type=script&lang=js"
export * from "./DetailsNew.vue?vue&type=script&lang=js"
import style0 from "./DetailsNew.vue?vue&type=style&index=0&id=7c7e7079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7e7079",
  null
  
)

export default component.exports